import React, { useRef, useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { DataLayersIconWithText, DataLayersIconWrapper, MobileDataLayerButtonText, MobileDataLayerButtonWrapper, MobileDataLayersTableCell, MobileSortButtonWrapper, SortHoverIconWrapper, TableHeaderCell, TableHeaderSortIconWrapper, TableHeaderTextWrapper, } from '../WealthOverviewPage.styles';
import { useStore } from '../../../../../app/data/root.store';
import { ReactComponent as DataLayersIcon } from '../assets/data-layers-icon.svg';
import { ReactComponent as SortIcon } from '../assets/sort-icon.svg';
import { ReactComponent as SortHoverIcon } from '../assets/sort-hover-icon.svg';
import { TableHeaderWrapper } from '../../../class/components/ClassPage.styles';
import { ItemsListHeaderTabs } from './ItemsListHeaderTabs';
import { MobileLeftCornerMask, MobileRightCornerMask } from '../../../../../../assets/icons/common/common-icons';

const dataLayersDefaultSortByDirectionAsc = ['class', 'category', 'customClass', 'customSubClass'];
export function ItemsListHeader(props) {
  const { wealthStore, uiStore, filtersStore, dataLayersStore, inflowOutflowDataLayersStore } = useStore();
  const [isTableHeaderFixed, setIsTableHeaderFixed] = useState(false);
  const tableHeaderRef = useRef(null)
  const handleColumHeaderClick = (dl) => {
    if (dataLayersStore.sortBy === dl.dataKey) {
      dataLayersStore.setSortDirection(dataLayersStore.sortByColumn.direction === 'asc' ? 'desc' : 'asc');
    } else {
      dataLayersStore.setSortBy(dl.dataKey);
      dataLayersStore.setSortByColumn({ ...dl, direction: dataLayersDefaultSortByDirectionAsc.includes(dl.dataKey) ? 'asc' : 'desc' });
    }
  }

  const handleMobileSortClick = () => {
    dataLayersStore.setSortDirection(dataLayersStore.sortByColumn.direction === 'desc' ? 'asc' : 'desc');
  }

  const getValueColumnName = () => {
    if (wealthStore.selectedClass?.id === 10) {
      return 'Balance'
    }

    if (['crypto-holdings', 'holdings', 'items'].includes(wealthStore.listViewMode) || (wealthStore.isAllocationsViewMode && wealthStore.allocateBy === 'accounts')) { return 'Asset value' }

    return wealthStore.isAllocationsViewMode && ['classes', 'categories'].includes(wealthStore.allocateBy) ? 'Total value' : 'Assets value'
  }

  const checkScroll = () => {

    if (tableHeaderRef.current) {
      const { y } = tableHeaderRef.current.getBoundingClientRect();
      // console.log(y);
      setIsTableHeaderFixed(y < 64);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScroll);

    // Initial check to set the state correctly on mount
    checkScroll();

    return () => window.removeEventListener('scroll', checkScroll);
  }, []);
  return (<Observer>{() => (
    <>
      <div ref={tableHeaderRef} style={{ width: '100%', height: isTableHeaderFixed ? '50px' : 0 }}></div>
      <TableHeaderWrapper
        isFixed={isTableHeaderFixed}
        withStickyBreadcrumbs={filtersStore.countActiveFilters > 0}
        isWithDataLayersButton={uiStore.isDesktopView}
        matricesColumns={wealthStore.viewType === 'cashflow' ? (uiStore.isDesktopView ? inflowOutflowDataLayersStore.columns.length : 1) : (dataLayersStore.dataLayersHeaders.length)}
        isCashFlowDataView={wealthStore.viewType === 'cashflow'}
      >

        <ItemsListHeaderTabs />

        {/* {wealthStore.viewType === 'overview' && wealthStore.listViewMode !== 'holdings' && <> */}
        {((wealthStore.viewType === 'overview') || (wealthStore.viewType === 'trends')) && <>
          {uiStore.isDesktopView ? <>
            <DataLayersIconWithText>
              <DataLayersIconWrapper onClick={() => { dataLayersStore.setShowDrawer(true) }}><DataLayersIcon /> Adjust</DataLayersIconWrapper>
            </DataLayersIconWithText>

            {dataLayersStore.dataLayersHeaders.map(dl => (
              <TableHeaderCell key={dl.dataKey} clickable onClick={() => { handleColumHeaderClick(dl) }}>
                {dl.htmlTitle ? <TableHeaderTextWrapper dangerouslySetInnerHTML={{ __html: dl.htmlTitle }} /> :
                  <TableHeaderTextWrapper>
                    {dl.title}
                    {dl.subTitle ? <><br />{dl.subTitle}</> : null}
                  </TableHeaderTextWrapper>}
                {dataLayersStore.sortBy === dl.dataKey ? <TableHeaderSortIconWrapper isAsc={dataLayersStore.sortByColumn.direction === 'asc'}>
                  {/* V */}
                  <SortIcon />
                </TableHeaderSortIconWrapper> : null}
                {dataLayersStore.sortBy !== dl.dataKey ? <SortHoverIconWrapper><SortHoverIcon /></SortHoverIconWrapper> : null}
              </TableHeaderCell>
            ))}
            <TableHeaderCell isValue clickable onClick={() => { handleColumHeaderClick({ dataKey: 'usdValue' }) }}>
              {dataLayersStore.sortBy === 'usdValue' ? <TableHeaderSortIconWrapper isValue isAsc={dataLayersStore.sortByColumn.direction === 'asc'}>
                {/* V */}
                <SortIcon />
              </TableHeaderSortIconWrapper> : null}
              {dataLayersStore.sortBy !== 'usdValue' ? <SortHoverIconWrapper><SortHoverIcon /></SortHoverIconWrapper> : null}
              <TableHeaderTextWrapper>{getValueColumnName()}</TableHeaderTextWrapper>
            </TableHeaderCell>
          </> : <>


            <MobileDataLayersTableCell >
              <MobileDataLayerButtonWrapper onClick={() => { dataLayersStore.setShowDrawer(true) }}>
                <MobileDataLayerButtonText>
                  {dataLayersStore.dataLayersHeaders.length > 0 ? `${dataLayersStore.dataLayersHeaders[0].title}${dataLayersStore.dataLayersHeaders[0].subTitle ? ' - ' + dataLayersStore.dataLayersHeaders[0].subTitle : ''}` : getValueColumnName()}
                </MobileDataLayerButtonText><DataLayersIcon />
              </MobileDataLayerButtonWrapper>
              <MobileSortButtonWrapper isValue isAsc={dataLayersStore.sortByColumn.direction === 'asc'} onClick={() => { handleMobileSortClick() }} >
                {/* V */}
                <SortIcon />
              </MobileSortButtonWrapper>

            </MobileDataLayersTableCell>

          </>}
        </>}

        {wealthStore.viewType === 'cashflow' && <>
          {(uiStore.isDesktopView ? inflowOutflowDataLayersStore.columns : [inflowOutflowDataLayersStore.columns[inflowOutflowDataLayersStore.columns.length - 1]]).map(cl => (
            <TableHeaderCell key={cl.label} isValue>
              {cl.label}
            </TableHeaderCell>
          ))}
        </>}

        {!uiStore.isDesktopView &&
          <>

            <MobileLeftCornerMask style={{ position: 'absolute', top: '0', left: '0' }} />
            <MobileRightCornerMask style={{ position: 'absolute', top: '0', right: '0' }} />
          </>
        }
      </TableHeaderWrapper>
    </>
  )}</Observer>)
}